import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  token: null,
  userName: null,
  emailId: null,
  embedUrl: null,
  userRole: [''],
  roleChanged: false,
  categoryList: [''],
  sectorList: [''],
  sessionChecking: true,
};

export const OktaAuthSlice = createSlice({
  name: 'oktaAuth',
  initialState,
  reducers: {
    setAuthToken: (state, action) => {
      sessionStorage.setItem('accessToken', action.payload);
      state.token = action.payload;
    },
    setUserName: (state, action) => {
      state.userName = action.payload;
    },
    setUserEmailId: (state, action) => {
      state.emailId = action.payload;
    },
    setEmbedUrl: (state, action) => {
      state.embedUrl = action.payload;
    },
    setUserRole: (state, action) => {
      state.userRole = action.payload;
    },
    setRoleChanged: (state, action) => {
      state.roleChanged = action.payload;
    },
    setCategoryList: (state, action) => {
      state.categoryList = action.payload;
    },
    setSectorList: (state, action) => {
      state.sectorList = action.payload;
    },
    setSessionChecking: (state, action) => {
      state.sessionChecking = action.payload;
    },
    clearAuthStore: (state) => {
      state.token = null;
      state.userName = null;
      state.emailId = null;
      state.userRole = [];
      state.roleChanged = false;
      state.categoryList = [''];
      state.sectorList = [''];
    },
  },
});

export const {
  setAuthToken,
  setUserName,
  setUserEmailId,
  setEmbedUrl,
  clearAuthStore,
  setUserRole,
  setRoleChanged,
  setCategoryList,
  setSectorList,
  setSessionChecking,
} = OktaAuthSlice.actions;

export const getAuthToken = (state: any) => state.oktaAuth.token;

export const getUserName = (state: any) => state.oktaAuth.userName;

export const getUserEmail = (state: any) => state?.oktaAuth?.emailId;

export const getEmbedUrl = (state: any) => state.oktaAuth.embedUrl;

export const getUserRole = (state: any) => state.oktaAuth.userRole;

export const getRoleChanged = (state: any) => state.oktaAuth.roleChanged;

export const getCategoryList = (state: any) => state.oktaAuth.categoryList;

export const getSectorList = (state: any) => state.oktaAuth.sectorList;

export const getSessionChecking = (state: any) =>
  state.oktaAuth.sessionChecking;

export default OktaAuthSlice.reducer;
